import { useEffect, useState } from 'react';
import StatsCard from '../components/StatsCard';
import RecentOrders from '../components/RecentOrders';
import QuickActions from '../components/QuickActions';
import { AdminAPI } from '../../shared/api/admin-api';
import { useNotification } from '../../shared/contexts/NotificationContext';
import LoadingSpinner from '../../shared/components/LoadingSpinner';

interface DashboardStats {
  orders: number;
  revenue: number;
  products: number;
  clients: number;
}

function Dashboard() {
  const [stats, setStats] = useState<DashboardStats>({
    orders: 0,
    revenue: 0,
    products: 0,
    clients: 0,
  });
  const [loading, setLoading] = useState(true);
  const { error } = useNotification();

  useEffect(() => {
    loadDashboard();
  }, []);

  const loadDashboard = async () => {
    try {
      const [products, orders, categories] = await Promise.all([
        AdminAPI.get('products').catch(() => []) as Promise<any[]>,
        AdminAPI.get('orders').catch(() => []) as Promise<any[]>,
        AdminAPI.get('categories').catch(() => []) as Promise<any[]>,
      ]);

      const productsData = await products;
      const ordersData = await orders;
      const categoriesData = await categories;

            const revenue = ordersData
                .filter((order: any) => order.status === 'delivered')
                .reduce((sum: number, order: any) => {
                    return sum + (parseFloat(order.total) || 0);
                }, 0);

            const uniqueClients = new Set(
                ordersData.map((order: any) => order.customer_id || order.customer_name)
            );

            setStats({
                orders: ordersData.length,
                revenue,
                products: productsData.length,
                clients: uniqueClients.size,
            });
    } catch (err: any) {
      console.error('Erro ao carregar dashboard:', err);
      error('Erro ao carregar dados do dashboard');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Loading Spinner - aparece apenas durante carregamento inicial */}
      {loading && <LoadingSpinner message="Carregando dashboard..." />}
      
      {/* Stats Cards */}
      <section className="stats-section">
        <div className="stats-grid">
          <StatsCard
            icon="shopping-cart"
            iconColor="blue"
            value={stats.orders.toString()}
            label="Pedidos"
          />
          <StatsCard
            icon="dollar-sign"
            iconColor="green"
            value={stats.revenue >= 1000 ? `R$ ${(stats.revenue / 1000).toFixed(1)}k` : `R$ ${stats.revenue.toFixed(2)}`}
            label="Vendas"
          />
          <StatsCard
            icon="box"
            iconColor="orange"
            value={stats.products.toString()}
            label="Produtos"
          />
          <StatsCard
            icon="users"
            iconColor="red"
            value={stats.clients.toString()}
            label="Clientes"
          />
        </div>
      </section>

      {/* Recent Orders */}
      <RecentOrders />

      {/* Quick Actions */}
      <QuickActions />
    </>
  );
}

export default Dashboard;

